<div class="w-full flex justify-center w-full flex-col pb-8 items-stretch"
    [class]="isTemplate()?'w-full p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700':''">
    <label [for]="uiId" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        @if(isTemplate()){
        <h5 class="mb-2 text-3xl font-bold text-gray-900 dark:text-white">Modifique o campo dos anexos
        </h5>
        } @else{
        {{placeHolder()}}{{required()?'*':''}}
        }
    </label>
    @if(isTemplate()){
    <ui-text placeHolder="Nome ou pergunta" [value]="placeHolder()" [editable]="true"
        (valueChange)="onPlaceholderChange($event)" />
    } @else{
    <div>
        @if(imageName()){
        <div *ngIf="imagePreview">
            <div class="flex gap-6 pb-4">
                <button [attr.data-modal-target]="'image-view-model-'+uiId"
                    [attr.data-modal-toggle]="'image-view-model-'+uiId"
                    class="grow block w-full md:w-auto text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    type="button">{{ imageName() }} ({{
                    fileSize()
                    }} KB)</button>
                @if(editable()){
                <button
                    class="block w-full md:w-auto text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    type="button" (click)="confirmPopup = true">Apagar</button>
                }
            </div>
            <div [id]="'image-view-model-'+uiId" tabindex="-1"
                class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
                <div class="relative w-full max-w-lg max-h-full">
                    <!-- Modal content -->
                    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <!-- Modal header -->
                        <div
                            class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                            <h3 class="text-xl font-medium text-gray-900 dark:text-white">
                                {{ imageName() }}
                            </h3>
                            <button type="button"
                                class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                [attr.data-modal-hide]="'image-view-model-'+uiId">
                                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 14 14">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                </svg>
                                <span class="sr-only">Close modal</span>
                            </button>
                        </div>
                        <!-- Modal body -->
                        <div class="p-4 md:p-5 space-y-4">
                            <img [src]="imagePreview()" alt="Image Preview" class="image-preview" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        @else if(!editable()){
        <span class="text-gray-400  hover:text-gray-900 dark:hover:text-white">Sem anexo</span>
        }
    </div>
    @if(editable() && !imageName()){
    <label [for]="uiId"
        class="w-full flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
        <div class="flex flex-col items-center text-center justify-center p-3">
            <svg class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
            </svg>
            <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">Para enviar imagem
                    clique aqui</span>
                ou arraste e solte</p>
            <p class="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
        </div>
        <input accept="image/*" [id]="uiId" type="file" class="hidden" (input)="onFileChange($event)" #fileInput
            [required]="required()" />
    </label>
    }
    }
</div>

<ui-alert-popup *ngIf="confirmPopup" [title]="'Confirmação'" [message]="'Deseja realmente excluir esta imagem?'"
    [icon]="EIcon.Trash" [type]="EAlert.DANGER" (confirm)="deleteClick()" (close)="confirmPopup = false" (cancel)="confirmPopup = false">
</ui-alert-popup>